import { render } from "./SpecFileResult.vue?vue&type=template&id=5c0553b2"
import script from "./SpecFileResult.vue?vue&type=script&lang=js"
export * from "./SpecFileResult.vue?vue&type=script&lang=js"

import "./SpecFileResult.vue?vue&type=style&index=0&id=5c0553b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tests/SpecFileResult.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c0553b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c0553b2', __exports__)) {
    api.reload('5c0553b2', __exports__)
  }
  
  module.hot.accept("./SpecFileResult.vue?vue&type=template&id=5c0553b2", () => {
    api.rerender('5c0553b2', render)
  })

}


export default __exports__